export const contentSeparator = '|' as const;
